import React, {useContext, useEffect, useState} from 'react'
import localization from "../../../../../../assets/localization/localization";
import Layout from "../../../../../../components/sales/layout/layout";
import DivLayout from "../../../../../../components/sales/divLayout/divLayout";
import ConstantInput from "../../../../../../components/sales/Input/constantInput/constantInput";
import {Button} from "react-bootstrap";
import {toast} from "react-toastify";
import CustomModal from "../../../../../valetServices/modal";
import ModalPop from "../../../../../../components/sales/modal/modal";
import {BaseUrl} from "../../../../../../contexts/baseUrl/baseUrl";

const ViewFixed = ({
                       match,
                       getValetContractInvoice,
                       valetContractInvoice = [],
                       lineItemsApprovalRejection,
                       lineItemsApprovalRejectionResponse = [],
                       history
                   }) => {

    const [listData, setListData] = useState([{}]);
    const [isLoading, setIsLoading] = useState(false);
    const [sum, setSum] = useState(0);
    const [isModal, setIsModal] = useState(false);
    const [approvalStatus, setApprovalStatus] = useState(0);
    const [remarks, setRemarks] = useState("");
    const [showModalContent, setShowModalContent] = useState(true)
    const [count, setCount] = useState(0)
    const [role, setRole] = useState('')
    const { baseUrl } = useContext(BaseUrl);
    const [invoiceNo, setInvoiceNo] = useState('');

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            setRole(localStorage.getItem("fusion-role"))
            getValetContractInvoice(1, 1, null, match?.params?.invoice_id)
            setIsLoading(false)
        })()
    }, []);

    useEffect(() => {
        if (valetContractInvoice && valetContractInvoice?.resultSets && valetContractInvoice?.resultSets.length > 0) {
            setListData(valetContractInvoice?.resultSets[0]?.item_data)
            setInvoiceNo(valetContractInvoice?.resultSets[0]?.invoice_number)
            setTimeout(() => {
                setIsLoading(true)
                setIsLoading(false)
            }, 500)
        }
    }, [valetContractInvoice])

    const handleInput = (key, index, val) => {
        let list = [...listData]
        list[index][key] = val
        setListData(list)
    }

    useEffect(() => {
        let list = [...listData]
        let s = 0;
        list.map(v => {
            s += v?.amount * v?.men_days * v?.quantity
            delete v?.meta_data
        })
        setSum(s)
    }, [listData])

    const handleSubmit = async () => {

        if(remarks === ""){
            toast.error("Remark is required");
            return false
        }
        const submitData = {
            remark: remarks,
            installment_invoice_id: match?.params?.invoice_id,
            action:approvalStatus,
            line_items:listData,
            invoice_no: invoiceNo
        };
        setShowModalContent(false)
        setIsLoading(true)
        await lineItemsApprovalRejection(submitData)
        setIsLoading(false)
        setCount(count + 1)
        setIsModal(false)
        setShowModalContent(true)
    }

    const setStatus = (status) => {
        setIsModal(true)
        setApprovalStatus(status)
    }

    {console.log(lineItemsApprovalRejectionResponse)}

    return (
        <>
            <Layout
                title={localization.viewDetail}
                isLoading={isLoading}
                isGoback={true}
            >
                {valetContractInvoice && valetContractInvoice?.resultSets && valetContractInvoice?.resultSets.length > 0 &&
                    <>
                        <div className="panel-card card-details" width="100%">
                            {lineItemsApprovalRejectionResponse !== null && lineItemsApprovalRejectionResponse?.response?.status !== 200 &&
                                <CustomModal msg={lineItemsApprovalRejectionResponse?.response?.message} click={count} history={history}/>}
                            {lineItemsApprovalRejectionResponse !== null && lineItemsApprovalRejectionResponse?.response?.status === 200 &&
                                <CustomModal msg={lineItemsApprovalRejectionResponse?.response?.message} isPageLoad={true} history={history} url={`${baseUrl}/valet-Fixed-invoice-list`} click={count}/>}
                            <div className="panel-heading">{localization.invoiceModule}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <DivLayout
                                        heading={"Invoice Id"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_id
                                        }
                                    />
                                    <DivLayout
                                        heading={"Invoice Number"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_number
                                        }
                                    />
                                    <DivLayout
                                        heading={"Invoice Date"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_date
                                        }
                                    />
                                    <DivLayout
                                        heading={"Invoice Type"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.invoice_type === 1 ? "Pre" : "Post"
                                        }
                                    />
                                    <DivLayout
                                        heading={"Net Payable"}
                                        data={
                                            valetContractInvoice?.resultSets[0]?.net_payable
                                        }
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="panel-card card-details" width="100%">
                            <div className="panel-heading">{localization.lineItem}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <table className="table table-responsive table-info">
                                        <thead>
                                        <th>Item</th>
                                        <th>Type</th>
                                        <th>Quantity</th>
                                        <th>Unit Price</th>
                                        <th>Men Days</th>
                                        <th>Total Men Days</th>
                                        <th>Total Price</th>
                                        </thead>
                                        <tbody>
                                        {listData !== undefined && listData.length > 0 && listData.map((val, i) => {
                                            return (
                                                <>
                                                    {val?.variable_type === 'O' &&
                                                        <tr>
                                                            <td>{val?.description}</td>
                                                            <td>{'On Demand'}</td>
                                                            <td>{val?.quantity}</td>
                                                            <td>{val?.amount}</td>
                                                            <td>{val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days * val.amount}</td>
                                                        </tr>
                                                    }
                                                    {val?.variable_type === 'V' &&
                                                        <tr>
                                                            <td>{val?.description}</td>
                                                            <td>{'Variable'}</td>
                                                            <td>{val?.quantity}</td>
                                                            <td>{val?.amount}</td>
                                                            <td>{val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days * val.amount}</td>
                                                        </tr>
                                                    }

                                                    {val?.variable_type === 'F' &&
                                                        <tr>
                                                            <td>{val?.description}</td>
                                                            <td>{'Fixed'}</td>
                                                            <td>{val?.quantity}</td>
                                                            <td>{val?.amount}</td>
                                                            <td>{val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days}</td>
                                                            <td>{val?.quantity * val?.men_days * val.amount}</td>
                                                        </tr>
                                                    }

                                                </>
                                            )
                                        })
                                        }
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Sum</td>
                                            <td>{sum}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {parseInt(role) === 47 &&
                                    <>
                                        <div className="container-fluid">
                                            <div className="text-center">
                                                <Button type="button" onClick={() => setStatus(2)} style={{'marginRight':'14%'}}>Approve</Button>
                                                <Button type="button"  onClick={() => setStatus(3)}>Reject</Button>
                                            </div>
                                        </div>

                                        {showModalContent &&
                                            <ModalPop
                                                title={localization.remark}
                                                show={isModal}
                                                handleModalHide={() => setIsModal(false)}
                                                isLoading={isLoading}
                                            >
                                                <ConstantInput
                                                    label={localization.remark}
                                                    value={""}
                                                    type="text"
                                                    handleChange={(val) =>
                                                        setRemarks(val)
                                                    }
                                                />
                                                <Button type="btn btn-danger" onClick={handleSubmit}>Submit</Button>
                                            </ModalPop>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    </>
                }

            </Layout>
        </>
    )
}

export default ViewFixed